import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchUpdateWorkflowView } from "apis";
import { TWorkflowView } from "@elixir/types";
import { useMyAccessProfileV2 } from "../get-my-access-profile";
import { getQueueConfigQueryKey } from "../get-queue-config";

export default function usePatchCreateWorkflowView() {
  const queryClient = useQueryClient();

  const { data: myAccessProfile } = useMyAccessProfileV2();
  const { user } = myAccessProfile ?? {};

  return useMutation(
    ({ view_id, data }: { view_id: string; data: TWorkflowView }) =>
      patchUpdateWorkflowView({ view_id, assignee_id: user?.oid!, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getQueueConfigQueryKey());
      },
    }
  );
}
